"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var BrandMessageTemplateTplRawEditor_1 = require("./BrandMessageTemplateTplRawEditor");
var BrandMessageTemplateTestJSONEditor_1 = require("./BrandMessageTemplateTestJSONEditor");
var BrandMessageTemplateOperationEdit = /** @class */ (function (_super) {
    __extends(BrandMessageTemplateOperationEdit, _super);
    function BrandMessageTemplateOperationEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_template = "tab.template";
        _this.tab_test = "tab.test";
        return _this;
    }
    BrandMessageTemplateOperationEdit.prototype.componentWillMount = function () {
        this.setState({
            templateImageMode: "LIST"
        });
        this.props.state.setExtBreadCrumbPath(["Управление шаблоном"]);
    };
    BrandMessageTemplateOperationEdit.prototype.backToRootClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    BrandMessageTemplateOperationEdit.prototype.getTPLRawEditorObject = function () {
        return (React.createElement(BrandMessageTemplateTplRawEditor_1.default, { data: this.props.dataTemplates, record: this.props.record, state: this.props.state, onGoBack: this.backToRootClick.bind(this), tplBase64: this.props.TPLBase64 }));
    };
    BrandMessageTemplateOperationEdit.prototype.getTestJSONEditorObject = function () {
        return (React.createElement(BrandMessageTemplateTestJSONEditor_1.default, { data: this.props.dataTemplates, record: this.props.record, state: this.props.state, onGoBack: this.backToRootClick.bind(this), testJSONBase64: this.props.JSONBase64 }));
    };
    BrandMessageTemplateOperationEdit.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_template },
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "envelope" }),
                        "\u0428\u0430\u0431\u043B\u043E\u043D"), key: this.tab_template }, this.getTPLRawEditorObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "calendar-check" }),
                        "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430"), key: this.tab_test }, this.getTestJSONEditorObject()))));
    };
    return BrandMessageTemplateOperationEdit;
}(React.Component));
exports.default = BrandMessageTemplateOperationEdit;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/message/BrandMessageTemplateOperations.tsx
// module id = 1806
// module chunks = 0